import { createSearchParams } from 'react-router-dom'

import type { Navigation } from 'modules/core/lib/navigation/context'
import type { NavigationPaths } from 'modules/core/lib/navigation/context'

export function settingsUrl(
  reviewId: string,
  navigation: Navigation<NavigationPaths>,
  section: string
) {
  return {
    pathname: navigation.performanceProcess.reviews.review.settings.fullPath({
      reviewId: String(reviewId),
    }),
    search: createSearchParams({ section: section }).toString(),
  }
}
